import { useQuery } from '@apollo/client';
import { GET_SUBSCRIPTION_PACKAGES } from '@shared/graphql/queries/subscriptionPackages';

interface UseUpgradeTooltipReturn {
  getUpgradeMessage: (trackType?: 'metro' | 'country') => string;
  isLoading: boolean;
  error?: any;
}

interface SubscriptionPackage {
  id: string;
  packageCode: string;
  name: string;
  description: string;
  priceWeekly: number;
  priceMonthly: number;
  tagRules: Array<{
    tag: {
      name: string;
    };
  }>;
}

export const useUpgradeTooltip = (): UseUpgradeTooltipReturn => {
  const { data, loading, error } = useQuery(GET_SUBSCRIPTION_PACKAGES);

  const getUpgradeMessage = (): string => {
    if (loading || !data?.getAvailablePackages) {
      return 'Upgrade to access more tracks with prices starting from $12.50';
    }

    const packages = data.getAvailablePackages as SubscriptionPackage[];
    
    // Find the lowest priced package
    let lowestPrice = Infinity;
    packages.forEach((pkg: SubscriptionPackage) => {
      if (pkg.priceWeekly && pkg.priceWeekly < lowestPrice) {
        lowestPrice = pkg.priceWeekly;
      }
    });

    if (lowestPrice !== Infinity) {
      return `Upgrade to access more tracks with prices starting from $${lowestPrice.toFixed(2)}`;
    }

    return 'Upgrade to access more tracks with prices starting from $12.50';
  };

  return {
    getUpgradeMessage,
    isLoading: loading,
    error
  };
};